// попап обратной связи
$(document).ready(function () {
  const popupFeedback = $(".popup-feedback");

  function isVisiblePopupWowEls() {
    WOW.prototype.isVisible = function (e) {
      if (this.isPositionFixed(e)) return true;
    };
  }

  $(".js-show-feedback").on("click", function () {
    popupFeedback.addClass("popup-opened"),
      new WOW({
        boxClass: "f-wow",
        animateClass: "animated",
        offset: 0,
        mobile: !0,
        live: !1,
      }).init();

    WOW.prototype.isPositionFixed = function (e) {
      for (
        var t;
        e.parentNode && "body" !== e.parentNode.localName && "fixed" !== t;

      )
        (t = getComputedStyle(e).position), (e = e.parentNode);
      return "fixed" === getComputedStyle(e).position;
    };
    isVisiblePopupWowEls();
  });

  $("#closeForm").on("click", function () {
    closePopup();
  });

  $(".feedback-form").on("submit", function (e) {
    e.preventDefault();
    const isFormValidate = checkFormValidate(this),
      $sendFormBtn = $(this).find(".form__btn"),
      $formParent = $(this).closest(".popup__content"),
      $successBlock = $formParent.siblings(".popup__success-block");

    if (isFormValidate) {
      let data = $(this).serialize() + "&action=feedback_form";

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "POST",
        cache: !1,
        data,
        dataType: "html",
        beforeSend: function () {
          $sendFormBtn.prop("disabled", 1);
        },
        success: function (n) {
          $formParent.removeClass("active");
          $successBlock.addClass("active");
          $sendFormBtn.prop("disabled", 0);
          $("#errorMessage").text("");

          setTimeout(function () {
            $formParent.addClass("active");
            $successBlock.removeClass("active");
            closePopup();
          }, 5000);
        },
      });

      // $.post("/wp-admin/admin-ajax.php", data, function (response) {
      //   console.log(response);
      //   //  n ? (o = "Спасибо, <br/>заявка <br/>принята!", r = "Скоро <br/>свяжемся <br/>с вами!", t.trigger("reset"), s(o, r), setTimeout((function() {
      // });
    }
  });

  function checkFormValidate(form) {
    let errorText = "";

    $(form)
      .find("input, textare")
      .each(function () {
        if ($(this).attr("type") == "text") {
          if ($(this).val().trim() == "") {
            errorText = $(this).data("js-validate-text");
            return false;
          }
        } else if ($(this).attr("type") == "checkbox") {
          if (!$(this).prop("checked")) {
            errorText = $(this).data("js-validate-text");
            return false;
          }
        }
      });
    $("#errorMessage").text(errorText);

    return errorText == "" ? true : false;
  }

  function closePopup() {
    popupFeedback.removeClass("popup-opened"),
      setTimeout(function () {
        $("#errorMessage").text(""),
          $("#name").val(""),
          $("#phone").val(""),
          $("#message").val(""),
          $("#agree").prop("checked", !1);
      }, 500),
      (WOW.prototype.isPositionFixed = function (e) {
        for (
          var t;
          e.parentNode && "body" !== e.parentNode.localName && "fixed" !== t;

        )
          (t = getComputedStyle(e).position), (e = e.parentNode);
        return "fixed" != getComputedStyle(e).position;
      }),
      isVisiblePopupWowEls();
  }
});
